import React from 'react';

import { MEDIA_INSERT_MENU_ITEM, MEDIA_SECTION } from '@atlaskit/editor-common/quick-insert/keys';
import { MEDIA_SECTION_RANK } from '@atlaskit/editor-common/quick-insert/rank';
import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';
import type { RegisterMenuItem } from '@atlaskit/editor-ui-control-model/types';

import type { MediaInsertPlugin, MediaInsertPluginConfig } from '../../mediaInsertPluginType';

import { MediaInsertQuickInsertMenuItem } from './MediaInsertQuickInsertMenuItem';

type Params = {
	api: ExtractInjectionAPI<MediaInsertPlugin> | undefined;
	config: MediaInsertPluginConfig | undefined;
};

export const getMediaInsertQuickInsertComponents = ({
	api,
	config,
}: Params): RegisterMenuItem[] => [
	{
		key: MEDIA_INSERT_MENU_ITEM.key,
		type: MEDIA_INSERT_MENU_ITEM.type,
		parents: [
			{
				key: MEDIA_SECTION.key,
				type: MEDIA_SECTION.type,
				rank: MEDIA_SECTION_RANK[MEDIA_INSERT_MENU_ITEM.key],
			},
		],
		component: () => <MediaInsertQuickInsertMenuItem api={api} config={config} />,
	},
];
